import { MenuRecord } from 'packages/core/records-old'

export const ReducerRecord = MenuRecord
